import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase =
  supabaseUrl && supabaseAnonKey && supabaseUrl !== 'your_supabase_project_url'
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null

export const isSupabaseEnabled = !!supabase
